import React, { createContext, useCallback, useContext, useState } from 'react';
import { Loading } from 'components/Loading';

interface IService {
  showLoading: () => void;
  hideLoading: () => void;
}

export const LoadingContext = createContext<IService>({
  showLoading: () => {},
  hideLoading: () => {},
});

export const LoadingProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [loading, setLoading] = useState(false);
  const showLoading = useCallback(() => setLoading(true), []);
  const hideLoading = useCallback(() => setLoading(false), []);

  return (
    <LoadingContext.Provider
      value={{
        showLoading,
        hideLoading,
      }}
    >
      {children}
      {loading && <Loading />}
    </LoadingContext.Provider>
  );
};

export const useLoadingService = () => useContext(LoadingContext);
